import { render, staticRenderFns } from "./alert-warning.vue?vue&type=template&id=03de30b0&scoped=true"
import script from "./alert-warning.vue?vue&type=script&lang=js"
export * from "./alert-warning.vue?vue&type=script&lang=js"
import style0 from "./alert-warning.vue?vue&type=style&index=0&id=03de30b0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03de30b0",
  null
  
)

export default component.exports